import axiosRequest from '../index'
import api from '../api'
import config from '../config'

const { env } = config
const needMock = true && env === 'LOCAL'
const mockData = ISDEVELOPMENT ? require('../mockData') : ''

// 获取电话、邮箱等联系方式
export function getPersonalInfo (mmaclientid) {
  if (needMock) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        resolve(mockData.personalInfo.data)
      }, Math.floor(Math.random() * 3))
    })
  }
  const url = api.personalinfo.replace('{mmaclientid}', mmaclientid)
  return axiosRequest(url, {
    needEncrypt: true,
    needXsign: true
  })
}

// 获取国旗图片
export function getFlags (uin) {
  const url = api.flags
    .replace('{uin}', uin)
  if (needMock) {
    return Promise.resolve(mockData.flags.data)
  }
  return axiosRequest(url)
}

// 保单列表
export function getPolicyList (mmaclientid, category, type, start, count) {
  const url = api.policyList
    .replace('{mmaclientid}', mmaclientid)
    .replace('{category}', category)
    .replace('{type}', type)
    .replace('{start}', start)
    .replace('{count}', count)
  if (needMock) {
    return Promise.resolve(mockData.policyList.data)
  }
  return axiosRequest(url, {
    needEncrypt: true,
    needXsign: true
  })
}

// 发起变更 (即磅、自动转账日期等)
export function changesvc (mmaclientid, policyno, body) {
  const url = api.changesvc
    .replace('{mmaclientid}', mmaclientid)
    .replace('{policyno}', policyno)
    .replace('{body}', body)
  if (needMock) {
    return Promise.resolve(mockData.changesvc)
  }
  return axiosRequest(url, {
    method: 'POST',
    data: body,
    needEncrypt: false,
    needXsign: false
  })
}

// 发起变更 (更改联系方式、通讯地址等)
export function changeContact (mmaclientid, body) {
  const url = api.changeContact
    .replace('{mmaclientid}', mmaclientid)
    .replace('{body}', body)
  if (needMock) {
    return Promise.resolve(mockData.changesvc)
  }
  return axiosRequest(url, {
    method: 'POST',
    data: body,
    needEncrypt: false,
    needXsign: false
  })
}

export function getBocmInfo (mmaclientid) {
  const url = api.bocmInfo
    .replace('{mmaclientid}', mmaclientid)
  // console.log('getBocmInfo', url)
  if (needMock) {
    return Promise.resolve(mockData.bocm)
  }
  return axiosRequest(url, {
    needEncrypt: true,
    needXsign: true
  })
}

export function getBanks (bankCodes) {
  const url = api.getBanks
    .replace('{bankCodes}', bankCodes.join(','))
  // console.log('getBanks', url)
  if (needMock) {
    return Promise.resolve(mockData.banks.data)
  }
  return axiosRequest(url, {
    needEncrypt: true,
    needXsign: true
  })
}

export function getBank (bankCode, branchCode) {
  const url = api.getBankName
    .replace('{bankCode}', bankCode)
    .replace('{branchCode}', branchCode)
  // console.log('getBankName', url)
  if (needMock) {
    return Promise.resolve(mockData.bank.data)
  }
  return axiosRequest(url, {
    needEncrypt: true,
    needXsign: true
  })
}

export function getFunctions (uin, type) {
  const url = api.getFunctions
    .replace('{uin}', uin)
    .replace('{type}', type)
  if (needMock) {
    return Promise.resolve(mockData.functions.data)
  }
  return axiosRequest(url, {
    needEncrypt: false,
    needXsign: false
  })
}
